export default {
  qrcode: {
    BackMessage: 'Back Message',
    ShowQRCode: 'Show QR Code',
    ChooseWeChatName: 'Choose WeChat Name',
    NickName: 'Nick Name',
    RefereeCode: 'Referee Code',
    RefereeName: 'Referee Name',
    Country: 'Country',
    Province: 'Province',
    City: 'City',
    Language: 'Language',
    HeadImgUrl: 'HeadImgUrl',
    IsSubscribe: 'IsSubscribe',
    SubscribeTime: 'SubscribeTime'
  }

}



// WEBPACK FOOTER //
// ./src/i18n/lang/en/wechat/qrcode.js